'use client';
import React from 'react';
import FilterBox from './FilterBox';
import { useBlogContext } from '@/context/BlogContext';

const Filter = ({
  isSticky = false,
  isPending = null,
  startTransition = null,
  scrollToBlogStart
}) => {
  const { filters } = useBlogContext();

  return (
    <div className={`flex flex-col w-full ${isSticky ? 'top-24 sticky' : ''}`}>
      <p className="font-inter-tight text-[#89D7DF] text-[18px]">
        FILTER ARTICLE
      </p>
      <span className="opacity-60 mt-4 border-[#8AD6DE] border-b w-full h-[1px]"></span>
      <div className="divide-opacity-60 divide-y divide-[#8AD6DE] w-full">
        {filters.map((filter, index) => {
          return (
            <FilterBox
              key={index}
              category={filter.category}
              tags={filter.tags}
              isPending={isPending}
              startTransition={startTransition}
              scrollToBlogStart={scrollToBlogStart}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Filter;
